import { RaceSummaryCaption, RunnerCaption, SelectionCaption, RaceSummaryRow } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummarySport/RaceSummary.style';
import { SelectionCast } from 'src/domains/sportsbook/webview/components/selectionCast/SelectionCast';
import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';

export const PlaceOnlyRaceSummaryCaption = withConfig(theme => styled(RaceSummaryCaption, { label: 'PlaceOnlyRaceSummaryCaption' })`
    height: 32px;
    border-style: solid;
    border-width: 0 0 0 1px;
    border-color: ${theme.star.selection.borderColor};
    width: 100%;
`);

export const PlaceOnlyRunnerCaption = withConfig(theme => styled(RunnerCaption, { label: 'PlaceOnlyRunnerCaption' })`
    border-right: 0;
    border-bottom: 1px solid ${theme.star.raceSummary.borderColor};
`);

export const PlaceOnlySelectionCaption = withConfig(theme => styled(SelectionCaption, { label: 'PlaceOnlySelectionCaption' })`
    flex: 0 0 64px;
    border-bottom: 1px solid ${theme.star.raceSummary.borderColor};
    white-space: normal;
    word-wrap: break-word;
    padding: 4px;
    font-size: 7px;
    margin-right: 1px;
    background: ${theme.star.raceSummary.bgColorSecondary};
`);

export const PlaceOnlySelectionCast = styled(SelectionCast, { label: 'PlaceOnlySelectionCast' })`
    flex: 0 0 64px;
`;

export const PlaceOnlyRaceSummaryRowHeader = styled(RaceSummaryRow, { label: 'PlaceOnlyRaceSummaryRowHeader' })`
    border-right: 0;
`;
